const StatusCertificado = Object.freeze({
  TODOS: 'Todos',
  VENCIDOS: 'Vencidos',
  A_VENCER: 'À vencer'
});

export default StatusCertificado;
